import * as no_NO from './no_NO'
import * as en_US from './en_US'

const nb_NO = no_NO
export {
  no_NO,
  en_US,
  nb_NO,
}
